import { useEffect, useState } from 'react';

import { ScanIqCustomerAnalyticsInfo } from '../../../../../interfaces/ScanIqCustomerAnalyticsInfo';
import { scanIqHomeService } from '../../../../../services/scanIqHomeService';
import { DateRangePreset } from '../../../../../../shared/constants/dateRangePreset';
import { getDateRangeByPreset } from '../../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';

type UseCustomerAnalyticsParams = {
  dateRangePreset: DateRangePreset;
};

type UseCustomerAnalyticsReturn = {
  customerAnalytics: ScanIqCustomerAnalyticsInfo | null;
};

export const useCustomerAnalytics = ({
  dateRangePreset,
}: UseCustomerAnalyticsParams): UseCustomerAnalyticsReturn => {
  const [customerAnalytics, setCustomerAnalytics] =
    useState<ScanIqCustomerAnalyticsInfo | null>(null);

  const fetchCustomerAnalytics = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);

    const data = await scanIqHomeService.getCustomerAnalytics(dateRange);
    setCustomerAnalytics(data);
  };

  useEffect(() => {
    fetchCustomerAnalytics();
  }, [dateRangePreset]);

  return { customerAnalytics };
};
